import { MouseEventHandler } from "react"

import styled from "styled-components"

import colors from "styles/colors"
import easing from "styles/easing"
import media from "styles/media"
import shadows from "styles/shadows"
import text from "styles/text"
import UniversalLink from "utils/Loader/UniversalLink"

export default function CarouselButton({
  onClick = () => {
    throw new Error("add an onClick prop to carousel button")
  },
  selected = false,
  route = "",
  children = null,
  variant = "default",
}: {
  onClick?: MouseEventHandler
  route?: string
  selected?: boolean
  children?: React.ReactNode
  variant?: string
}) {
  let stateColors

  switch (variant) {
    case "blue":
      stateColors = {
        background: {
          default: colors.blue400,
          hover: colors.white,
          active: colors.blue10,
        },
        text: {
          default: colors.white,
          hover: colors.blue400,
          active: colors.blue400,
        },
      }
      break
    case "clear":
      stateColors = {
        background: {
          default: "transparent",
          hover: colors.blue400,
          active: colors.blue10,
        },
        text: {
          default: colors.white,
          hover: colors.white,
          active: colors.blue400,
        },
      }
      break

    case "magenta":
      stateColors = {
        background: {
          default: colors.magenta400,
          hover: colors.white,
          active: colors.magenta10,
        },
        text: {
          default: colors.white,
          hover: colors.magenta400,
          active: colors.magenta400,
        },
      }
      break
    case "turq":
      stateColors = {
        background: {
          default: colors.turq400,
          hover: colors.white,
          active: colors.turq50,
        },
        text: {
          default: colors.white,
          hover: colors.turq400,
          active: colors.turq400,
        },
      }
      break
    case "white":
      stateColors = {
        background: {
          default: colors.white,
          hover: colors.blue10,
          active: colors.blue50,
        },
        text: {
          default: colors.blue400,
          hover: colors.blue400,
          active: colors.white,
        },
      }
      break
    default:
      stateColors = {
        background: {
          default: colors.blue10,
          hover: colors.white,
          active: colors.blue500,
        },
        text: {
          default: colors.blue800,
          hover: colors.blue800,
          active: colors.blue800,
        },
      }
      break
  }

  if (selected) {
    stateColors = {
      background: {
        default: colors.blue400,
        hover: colors.blue400,
        active: colors.blue400,
      },
      text: {
        default: colors.white,
        hover: colors.white,
        active: colors.white,
      },
    }
  }

  return !route ? (
    <Wrapper
      border={variant === "clear"}
      stateColors={stateColors}
      onClick={onClick}
    >
      {children}
    </Wrapper>
  ) : (
    <UniversalLink to={route}>
      <WrapperLink stateColors={stateColors}>{children}</WrapperLink>
    </UniversalLink>
  )
}

const Wrapper = styled.button<{
  stateColors: {
    background: {
      default: string
      hover: string
      active: string
    }
    text: {
      default: string
      hover: string
      active: string
    }
  }
  border?: boolean
}>`
  ${text.bodyS}
  border: ${({ border }) => (border ? "1px solid white" : "none")};
  display: flex;
  justify-content: center;
  align-items: center;

  ${shadows.lightModeButtonShadow}
  background-color: ${({ stateColors }) => stateColors.background.default};
  color: ${({ stateColors }) => stateColors.text.default};
  transition-duration: 300ms;
  transition-timing-function: ${easing.button};

  ${media.hover} {
    :hover {
      background-color: ${({ stateColors }) => stateColors.background.hover};
      color: ${({ stateColors }) => stateColors.text.hover};
    }
  }

  :active {
    background-color: ${({ stateColors }) => stateColors.background.active};
    color: ${({ stateColors }) => stateColors.text.active};
  }
  ${media.fullWidth} {
    padding: 0 15px;
    height: 30px;
    border-radius: 40px;
  }
  ${media.desktop} {
    padding: 0 0.904vw;
    height: 1.807vw;
    border-radius: 2.41vw;
  }
  ${media.tablet} {
    padding: 0 1.465vw;
    height: 2.93vw;
    border-radius: 3.906vw;
  }
  ${media.mobile} {
    padding: 0 4vw;
    height: 8vw;
    border-radius: 10.667vw;
  }
`

const WrapperLink = styled.div<{
  stateColors: {
    background: {
      default: string
      hover: string
      active: string
    }
    text: {
      default: string
      hover: string
      active: string
    }
  }
}>`
  ${text.bodyS}
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  ${shadows.lightModeButtonShadow}
  background-color: ${({ stateColors }) => stateColors.background.default};
  color: ${({ stateColors }) => stateColors.text.default};
  transition-duration: 300ms;
  transition-timing-function: ${easing.button};

  ${media.hover} {
    :hover {
      background-color: ${({ stateColors }) => stateColors.background.hover};
      color: ${({ stateColors }) => stateColors.text.hover};
    }
  }

  :active {
    background-color: ${({ stateColors }) => stateColors.background.active};
    color: ${({ stateColors }) => stateColors.text.active};
  }
  ${media.fullWidth} {
    padding: 0 15px;
    height: 30px;
    border-radius: 40px;
  }
  ${media.desktop} {
    padding: 0 0.904vw;
    height: 1.807vw;
    border-radius: 2.41vw;
  }
  ${media.tablet} {
    padding: 0 1.465vw;
    height: 2.93vw;
    border-radius: 3.906vw;
  }
  ${media.mobile} {
    padding: 0 4vw;
    height: 8vw;
    border-radius: 10.667vw;
  }
`
